import { StringInput } from './StringInput';
import { NumberInput } from './NumberInput';
import { DateInput } from './DateInput';
import { BooleanInput } from './BooleanInput';
import { ArrayInput } from './ArrayInput';
import { ObjectInput } from './ObjectInput';
import {
  ValueWrapper,
  ValueWrapperBoolean,
  ValueWrapperArray,
} from './ValueWrapper';
import Stack from '@mui/material/Stack';

export type AnyInputProps<T> = {
  input: ValueWrapper<T>;
  onChange: (value: T) => void;
  object: T;
};

export const AnyInput = <T,>({
  input,
  onChange,
  object,
}: AnyInputProps<T>): JSX.Element => {
  if ('value' in input) {
    const { value } = input;
    if (typeof value === 'string') {
      return (
        <StringInput
          {...(input as ValueWrapper<string>)}
          onChange={(value) => onChange(value as unknown as T)}
        />
      );
    }
    if (typeof value === 'number') {
      return (
        <NumberInput
          {...(input as ValueWrapper<number>)}
          onChange={(value) => onChange(value as unknown as T)}
        />
      );
    }
    if (value instanceof Date) {
      return (
        <DateInput
          {...(input as ValueWrapper<Date>)}
          onChange={(value) => onChange(value as unknown as T)}
        />
      );
    }
    if (typeof value === 'boolean') {
      return (
        <BooleanInput
          {...(input as ValueWrapperBoolean)}
          onChange={(value) => onChange(value as unknown as T)}
        />
      );
    }
  }
  if ('element' in input) {
    return (
      <Stack sx={{ ml: 2 }}>
        <ArrayInput
          input={input as unknown as ValueWrapperArray<unknown>}
          onChange={(value) => onChange(value as unknown as T)}
          values={object as Array<unknown>}
        />
      </Stack>
    );
  }
  return (
    <Stack sx={{ ml: 2 }}>
      <ObjectInput
        input={input as ValueWrapper<Record<string, unknown>>}
        onChange={(value) => onChange(value as unknown as T)}
        object={object as Record<string, unknown>}
      />
    </Stack>
  );
};
